function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    style: {
      "textIndent": 0,
      "textAlign": "start",
      "lineHeight": "normal",
      "textTransform": "none",
      "blockProgression": "tb",
      "InkscapeFontSpecification": "Bitstream Vera Sans"
    },
    d: "M 6 4 L 6 5 L 6 27 L 6 28 L 7 28 L 25 28 L 26 28 L 26 27 L 26 5 L 26 4 L 25 4 L 7 4 L 6 4 z M 8 6 L 24 6 L 24 26 L 8 26 L 8 6 z M 10 10 L 10 12 L 22 12 L 22 10 L 10 10 z M 10 16 L 10 18 L 17 18 L 17 16 L 10 16 z M 19 16 L 19 18 L 22 18 L 22 16 L 19 16 z M 10 20 L 10 22 L 17 22 L 17 20 L 10 20 z M 19 20 L 19 22 L 22 22 L 22 20 L 19 20 z"
  }));
};

export default __webpack_public_path__ + "static/media/bill.5ad4e337.svg";
export { SvgComponent as ReactComponent };